import React from "react"
import "./index.css"

export default (props) => (
    <div className="waveWrapper waveAnimation">
        <div className="container col-12">
            {props.children}
        </div>
        <div className="waveWrapperInner bgTop">
            <div className="wave waveTop" style={{ backgroundImage: "url('/wave-bg/wave-top-dark.svg')" }}></div>
        </div>
        <div className="waveWrapperInner bgMiddle">
            <div className="wave waveMiddle" style={{ backgroundImage: "url('/wave-bg/wave-mid-dark.svg')" }}></div>
        </div>
        <div className="waveWrapperInner bgBottom">
            <div className="wave waveBottom" style={{ backgroundImage: "url('/wave-bg/wave-bot-dark.svg')" }}></div>
        </div>
    </div >
)